import * as React from 'react';
import styles from './ManualSolicitationEditor.module.css';
import { cn } from '@/lib/utils';

export interface ManualSolicitationState {
	type: 'Update' | 'Edit';
	content: string;
}

export interface ManualSolicitationEditorProps
	extends React.HTMLAttributes<HTMLDivElement> {
	placeholder?: string;
	className?: string;
	value?: string;
	state?: ManualSolicitationState;
	onChange: React.FormEventHandler<HTMLDivElement>;
	onFocus: React.FormEventHandler<HTMLDivElement>;
	onUpdateState?: () => void;
}

const ManualSolicitationEditor = React.forwardRef<
	HTMLDivElement,
	ManualSolicitationEditorProps
>(
	(
		{
			state,
			placeholder = '',
			value = '',
			className = '',
			onChange,
			onFocus,
			onUpdateState,
		},
		ref
	) => {
		const editorRef = React.useRef<HTMLDivElement>(null);

		if (state?.type === 'Update' && editorRef?.current) {
			editorRef.current.textContent = state.content;
			onUpdateState && onUpdateState();
		}

		const handlePaste = (e) => {
			e.preventDefault(); // Prevent the default paste behavior
			const text = e.clipboardData.getData('text/plain'); // Get plain text from clipboard
			// Insert the plain text into the content editable div
			document.execCommand('insertText', false, text);
		};

		return (
			<div ref={ref}>
				<div
					ref={editorRef}
					title={placeholder}
					contentEditable={true}
					suppressContentEditableWarning={true}
					className={cn(styles.customEditor, className)}
					onChange={onChange}
					onInput={onChange}
					onFocus={onFocus}
					onPaste={handlePaste}
				>
					{value}
				</div>
			</div>
		);
	}
);
ManualSolicitationEditor.displayName = 'ManualSolicitationEditor';

export default ManualSolicitationEditor;
